export default "__VITE_ASSET__DwQKmFEW__"